import React from "react";
import { CopyableCodeLine } from "onboarding/components/NumberedStep";
import { track } from "utils/track";
import EnvironmentSelector from "../../components/EnvironmentSelector";
import TokenSelector from "../../components/TokenSelector";
import { ExternalLink } from "components/ExternalLink";

const INSTALLATION_URL =
  "https://github.com/solarwinds/solarwinds-snap-agent-docker/#installation";

export default props => {
  const environmentSelect = {
    title: "Select Environment",
    content: <EnvironmentSelector />,
  };

  const tokenSelect = {
    title: "Select API Token",
    content: <TokenSelector />,
  };

  let steps = [
    {
      precedingContent:
        "Deploy the AppOptics DaemonSet to Kubernetes. This will gather metrics from each node in the cluster.",
      title: (
        <div>
          {`Follow the instructions found on `}
          <ExternalLink href={INSTALLATION_URL}>
            SolarWinds&nbsp;GitHub&nbsp;site
          </ExternalLink>
          {` using the token below: `}
        </div>
      ),
      content: (
        <div onClick={_ => track("Copied Kubernetes API token")}>
          <CopyableCodeLine>{props.agentRecorderToken}</CopyableCodeLine>
        </div>
      ),
    },
  ];

  if (props.onboardingState.showModal) {
    return steps;
  } else if (props.environmentsWithTokenCount === 0) {
    steps.unshift(tokenSelect);
  } else {
    steps.unshift(environmentSelect, tokenSelect);
  }

  return steps;
};
